<div nz-row>
  <div
    nz-col
    [ngClass]="{
      'has-error': hasError
    }"
  >
    <nz-input-group
      [attr.data-cy]="'end-users-searchbar'"
      nzCompact
      nzSize="large"
      [nzSuffix]="suffixIconButton"
      [nzAddOnBefore]="prefixButton"
    >
      <input
        type="text"
        nz-input
        id="end-users-searchbar-input"
        [(ngModel)]="consumerId"
        style="width: 350px"
        [placeholder]="searchBarPlaceHolder"
        (ngModelChange)="onConsumerIdChange($event)"
        (keydown.enter)="fetchEndUser()"
      />
    </nz-input-group>
    <ng-template #suffixIconButton>
      <i
        *ngIf="!loadingEndUser"
        (click)="fetchEndUser()"
        nz-icon
        nzType="search"
        class="search-btn"
        nzSize="large"
        [ngClass]="{ disabled: !consumerId }"
      ></i>
      <ng-container *ngIf="loadingEndUser">
        <ng-template #indicatorTemplate
          ><i nz-icon nzType="loading"></i
        ></ng-template>
        <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
      </ng-container>
    </ng-template>
    <ng-template #prefixButton>
      <nz-select
        id="end-users-searchbar-select"
        nzSize="large"
        [(ngModel)]="consumerIdentityParam"
        style="min-width: 150px"
        (ngModelChange)="updateConsumerIdentityParam($event)"
      >
        <nz-option
          *ngFor="let consumerIdentity of consumerIdentityList"
          [nzLabel]="consumerIdentity.label | translate"
          [nzValue]="consumerIdentity.value"
        ></nz-option>
      </nz-select>
    </ng-template>
  </div>
</div>
